import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Header from '../../containers/header'
import Footer from './Footer'
import isElectron from '../../utils/isElectron'
import { DexThemeProvider } from './DexThemeProvider'

const Wrapper = styled.div`
  height: 100%;
`

const Content = styled.div`
  flex-grow: 1;
  padding: 60px 0;
`

export default class Layout extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: null,
  }

  render() {
    const { children } = this.props
    return (
      <Wrapper>
        {isElectron() ? (
          <Header />
        ) : (
          <DexThemeProvider theme="dark">
            <Header />
          </DexThemeProvider>
        )}
        <Content>{children}</Content>
        {isElectron() ? (
          <Footer />
        ) : (
          <DexThemeProvider theme="dark">
            <Footer />
          </DexThemeProvider>
        )}
      </Wrapper>
    )
  }
}

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const RowGroup = styled(Row)`
  padding: 12px 24px;
  flex-wrap: wrap;
`

export const Column = styled.div`
  flex: ${({ flex }) => (flex !== undefined ? flex : 1)};
`
